import { render } from "./AuthorInput.vue?vue&type=template&id=c2cb3662&scoped=true&ts=true"
import script from "./AuthorInput.vue?vue&type=script&lang=ts"
export * from "./AuthorInput.vue?vue&type=script&lang=ts"

import "./AuthorInput.vue?vue&type=style&index=0&id=c2cb3662&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2cb3662"]])

export default __exports__